import React from 'react';
import PropTypes from 'prop-types';
import IndexPage from '../components/FullIndex';
import TemplateWrapper from '../layouts';

export const IndexPageTemplate = ({
  hero, about, engineering, sponsors, faq, pastLeaders, hackerStories, judges, disableLogin,
}) => (
  <IndexPage
    hero={hero}
    about={about}
    engineering={engineering}
    sponsors={sponsors}
    faq={faq}
    pastLeaders={pastLeaders}
    hackerStories={hackerStories}
    judges={judges}
    disableLogin={disableLogin}
  />
);

export default ({ data }) => { // eslint-disable-line react/prop-types
  const { frontmatter } = data.markdownRemark;
  return (
    <TemplateWrapper>{
      () => (
        <IndexPageTemplate
          hero={frontmatter.hero}
          about={frontmatter.about}
          engineering={frontmatter.engineering}
          sponsors={frontmatter.sponsors}
          faq={frontmatter.faq}
          pastLeaders={frontmatter.past_leaders}
          hackerStories={frontmatter.hacker_stories}
          judges={frontmatter.judges}
        />
      )
    }
    </TemplateWrapper>
  );
};

IndexPageTemplate.propTypes = {
  hero: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  about: PropTypes.string.isRequired,
  hackerStories: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  engineering: PropTypes.string.isRequired,
  sponsors: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  faq: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  pastLeaders: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  judges: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types,
  disableLogin: PropTypes.bool,
};

IndexPageTemplate.defaultProps = {
  disableLogin: false,
};

// eslint-disable-next-line no-undef
export const productPageQuery = graphql`
  query ProductPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        hero {
          date
          headline_phrases {
            phrase_object {
              colour
              phrase
            }
          }
          headline_suffix
          location
          sign_up_input {
            cta
            label
            placeholder
          }
          sponsor_cta {
            text
            link
          }
          buttons {
            submissions
          }
        }
        about
        engineering
        hacker_stories {
          body
          hacker_stories_list {
            hacker_stories_object {
              image
              link
              name
              quote
              project
            }
          }
        }
        judges {
          keynote {
            title
            image
            body
            watch
          }
          judges_title
          judge_list {
            judge {
              name
              image
              description
            }
          }
        }
        past_leaders {
          body
          past_leaders_list {
            past_leader {
              name
              description
              image
            }
          }
        }
        sponsors {
          sponsor_us
          sponsor_list_heading
          partner_list_heading
          sponsor_list {
            sponsor_object {
              link
              image
              tier
              alt
              padding
            }
          }
        }
        faq {
          title
          faq_about {
            faq_item {
              question
              answer
            }
          }
          faq_hacking {
            faq_item {
              question
              answer
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/index-page.jsx